import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const GTM_ID = 'GTM-N2N3R4WP'
const SCRIPT_ID = 'gtm-checkout-script'
const NOSCRIPT_ID = 'gtm-checkout-noscript'

/**
 * Injeta o Google Tag Manager apenas nas rotas de checkout.
 * Remove os elementos ao sair das rotas de checkout.
 */
export function CheckoutGTM() {
    const { pathname } = useLocation()
    const isCheckout = pathname.includes('/checkout')

    useEffect(() => {
        if (isCheckout) {
            if (!document.getElementById(SCRIPT_ID)) {
                const script = document.createElement('script')
                script.id = SCRIPT_ID
                script.innerHTML = `;(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${GTM_ID}');`
                document.head.insertBefore(script, document.head.firstChild)
            }

            if (!document.getElementById(NOSCRIPT_ID)) {
                const noscript = document.createElement('noscript')
                noscript.id = NOSCRIPT_ID
                const iframe = document.createElement('iframe')
                iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`
                iframe.height = '0'
                iframe.width = '0'
                iframe.style.cssText = 'display:none;visibility:hidden'
                noscript.appendChild(iframe)
                document.body.insertBefore(noscript, document.body.firstChild)
            }
        } else {
            document.getElementById(SCRIPT_ID)?.remove()
            document.getElementById(NOSCRIPT_ID)?.remove()
        }
    }, [isCheckout])

    return null
}
